/**
 * Copy limits for sponsor creatives, sized to what the app cards can show
 * (headline 2 lines, body 2 lines, CTA 1 line on a 78%-width sheet card).
 */
export const COPY_LIMITS = {
  headline: { min: 4, recommended: 32, max: 40 },
  body: { recommended: 90, max: 120 },
  cta: { max: 20 },
} as const;

const PLACEHOLDER_WORDS = new Set([
  'test', 'testing', 'tester', 'asdf', 'qwerty', 'lorem', 'lorem ipsum',
  'headline', 'title', 'todo', 'tbd', 'xxx', 'sample', 'placeholder',
]);

export interface CreativeCopyInput {
  headline: string;
  body: string;
  ctaText: string;
}

/**
 * Returns blocking problems with the copy. An empty list means it can ship.
 */
export function creativeCopyIssues({ headline, body, ctaText }: CreativeCopyInput): string[] {
  const issues: string[] = [];
  const h = headline.trim();
  const b = body.trim();
  const c = ctaText.trim();

  if (h.length < COPY_LIMITS.headline.min) {
    issues.push(`Headline needs at least ${COPY_LIMITS.headline.min} characters.`);
  } else if (PLACEHOLDER_WORDS.has(h.toLowerCase()) || /^(.)\1+$/i.test(h) || !/[a-z]{3}/i.test(h)) {
    issues.push('Headline looks like placeholder text. Write the real offer.');
  }
  if (h.length > COPY_LIMITS.headline.max) {
    issues.push(`Headline is ${h.length} characters. Keep it under ${COPY_LIMITS.headline.max} so it is not cut off.`);
  }
  if (b && PLACEHOLDER_WORDS.has(b.toLowerCase())) {
    issues.push('Body looks like placeholder text.');
  }
  if (b.length > COPY_LIMITS.body.max) {
    issues.push(`Body is ${b.length} characters. Keep it under ${COPY_LIMITS.body.max}.`);
  }
  if (c.length > COPY_LIMITS.cta.max) {
    issues.push(`Button text is ${c.length} characters. Keep it under ${COPY_LIMITS.cta.max}.`);
  }
  return issues;
}
